// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"available-market_buttonsWrapper__oSXqF","button":"available-market_button__ItPlG","accent":"available-market_accent__3c_3_"};